import _ from "lodash";
import BigNumber from "bignumber.js";
export function smartFormat(value) {
    if (value >= 1000000000) {
        return (value / 1000000000).toFixed(1).replace(".0", "") + "B";
    }
    if (value >= 1000000) {
        return (value / 1000000).toFixed(1).replace(".0", "") + "M";
    }
    if (value >= 1000) {
        return (value / 1000).toFixed(1).replace(".0", "") + "K";
    }
    return value.toString();
}
export function formatDecimalStatic({ value = "", decimal = 0, indent = 2, price = 1, smartIndent = false, trimZeros = true } = {}) {
    // Форматирование исходного значения
    const getFormatedValue = () => {
        const val = value ? value.toString().replace(",", ".") : "0";
        if (decimal === 0) {
            return val;
        }
        let result;
        if (typeof value === "number") {
            result = new BigNumber(val);
        }
        else {
            const divisor = new BigNumber(10).pow(decimal);
            result = new BigNumber(val).dividedBy(divisor);
        }
        // Умножаем на price если нужно
        if (price !== 1) {
            result = result.multipliedBy(price);
        }
        return result.toFixed(decimal, BigNumber.ROUND_DOWN);
    };
    // Определение количества знаков после запятой (логика getIndent)
    const getIndent = (value) => {
        let calculatedIndent = indent;
        const [, fractionalPart] = value.split(".");
        if (!fractionalPart) {
            return calculatedIndent;
        }
        if (smartIndent) {
            let zeroCount = 0;
            for (let i = 0; i < fractionalPart.length; i++) {
                if (fractionalPart[i] === "0") {
                    zeroCount++;
                }
                else {
                    break;
                }
            }
            calculatedIndent += zeroCount;
        }
        const takenFractional = fractionalPart.slice(0, calculatedIndent);
        if (trimZeros) {
            let zeroFromEndCount = 0;
            for (let i = takenFractional.length - 1; i >= 0; i--) {
                if (takenFractional[i] === "0") {
                    zeroFromEndCount++;
                }
                else {
                    break;
                }
            }
            calculatedIndent -= zeroFromEndCount;
            const lengthWithoutZeroes = takenFractional.length - zeroFromEndCount;
            calculatedIndent = Math.min(calculatedIndent, lengthWithoutZeroes);
        }
        return Math.max(0, calculatedIndent);
    };
    // Основная логика форматирования
    const formatValue = () => {
        const val = getFormatedValue();
        if (!val || !val.includes(".")) {
            return Number(val).toLocaleString("ru", {
                maximumFractionDigits: indent,
                roundingMode: "trunc"
            }).replace(",", ".");
        }
        const calculatedIndent = getIndent(val);
        const fractionalPart = _.split(val, ".")[1];
        const splitedValue = _.split(val, ".")[0] + "." + _.take(fractionalPart, calculatedIndent).join("");
        const formatted = BigNumber(splitedValue).toFormat(calculatedIndent, BigNumber.ROUND_DOWN, {
            groupSeparator: "\u00A0",
            decimalSeparator: ",",
            groupSize: 3
        });
        return formatted.replace(",", ".");
    };
    return formatValue();
}
